<template>
  <assistant-step :label="$t('location.label')" :title="$t(`${step.id}.title`)">
    <gc-form v-model="formValid" @submit.prevent="onNext()">
      <gc-row>
        <gc-col>
          <form-field
            :form-data="formData"
            field-name="lisArea"
            :step="step"
            :assistantContext="assistantContext"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row v-if="assistantContext.location.lisArea.includes('other')">
        <gc-col>
          <form-field
            :form-data="formData"
            field-name="customLisArea"
            :step="step"
            :assistantContext="assistantContext"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col cols="12" sm="12">
          <form-field
            :form-data="formData"
            field-name="alreadyHasLis"
            :step="step"
            hide-label
            :assistantContext="assistantContext"
          ></form-field>
        </gc-col>
      </gc-row>
      <gc-row>
        <gc-col cols="12" sm="12">
          <form-field
            :form-data="formData"
            field-name="chargingPoints"
            :step="step"
            :assistantContext="assistantContext"
          ></form-field>
        </gc-col>
      </gc-row>
    </gc-form>

    <assistant-step-navigation
      :assistantContext="assistantContext"
      :step="step"
      :steps="steps"
      :submit="step.submit"
      :valid="formValid"
      :show-back-button="false"
      @next="onNext()"
      @prev="onPrev()"
    />
  </assistant-step>
</template>

<script lang="ts">
import { defineComponent, ref } from '@vue/composition-api';
import AssistantStepNavigation from '@/components/AssistantStepNavigation.vue';
import MultipleChoice from '@/components/MultipleChoice.vue';
import { getStepContext } from '@/lib/context';
import { stepComponentProps } from '@/lib/steps/helper';
import FormField from '@/components/FormField.vue';
import { useBaseTransitions } from '@/lib/xstate/transitions';
import GcCol from '@/components/primitives/GcCol.vue';
import GcForm from '@/components/primitives/GcForm.vue';
import GcRow from '@/components/primitives/GcRow.vue';
import AssistantStep from '@/components/AssistantStep.vue';

export default defineComponent({
  components: {
    AssistantStep,
    AssistantStepNavigation,
    FormField,
    GcCol,
    GcForm,
    GcRow,
    MultipleChoice,
  },
  props: {
    ...stepComponentProps,
  },
  setup: (props, { emit }) => {
    const { onNext, onPrev } = useBaseTransitions(
      emit,
      props.assistantContext,
      props.step,
    );
    const formData = getStepContext(props.assistantContext, props.step);
    const formValid = ref(false);

    return {
      formData,
      formValid,
      onNext,
      onPrev,
    };
  },
});
</script>
